
export class ConsultaExtratoPreviModel {

    constructor(
        public cdHistorico?: string,
        public vlSaldo?: number,
        public vlLancto?: number,
        public sgHistorico?: string,
        public sqLancto?: string,
        public dtRef?: string
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/consulta-extrato-previ.model.ts